const ErrorState = ({
  message = "دریافت اطلاعات با خطا مواجه شد.",
  onRetry,
}) => (
  <div className="flex w-full flex-col items-center justify-center gap-4 py-24 text-center">
    <p className="text-sm text-gray-300">{message}</p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="rounded bg-brand px-6 py-2 text-sm font-semibold text-white transition hover:bg-brand-dark"
      >
        تلاش دوباره
      </button>
    )}
  </div>
);

export default ErrorState;
